
  <div class="slide_show_page">
  <div class="content_area" >
    <div class="nav_arrows">
      <span (click)="prevSlide()" class="arrow left_arrow">❮</span>
      <span (click)="nextSlide()" class="arrow right_arrow">❯</span>
    </div>
    <div class="image_container"  @slideAnimation >
      <img [src]="currentImage" alt="Image" class="side_image">
      <div class="overlay_text" [ngStyle]="{'background-image':currentBackground}" >
        <div class="current_header" >{{ currentHeading }}</div>
        <div class="current_text">{{ currentText }}</div>
        <ul>
          <li *ngFor="let benefit of currentBenefits" >{{ benefit }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
